import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  Announcement,
  AnnouncementCreateRequest,
} from '../models/announcements';
import { PaginatedResponse } from '../../../shared/interfaces/pagination';
import { SharedConnectionUsers } from '../../../shared/models/shared-connection-users';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementsService {
  private apiUrl = environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getSentMails(
    page = 1,
    pageSize = 10,
    email?: boolean,
    notification?: boolean,
  ): Observable<PaginatedResponse<Announcement>> {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());
    if (email !== undefined) {
      params = params.set('email', email.toString());
    }
    if (notification !== undefined) {
      params = params.set('notification', notification.toString());
    }
    return this.http.get<PaginatedResponse<Announcement>>(
      `${this.apiUrl}/api/admin/announcements`,
      {
        params,
      },
    );
  }

  sendEmail(
    email: AnnouncementCreateRequest,
  ): Observable<AnnouncementCreateRequest> {
    return this.http.post<AnnouncementCreateRequest>(
      `${this.apiUrl}/api/admin/announcements`,
      email,
    );
  }

  getConnections(
    search: string,
    page = 1,
    pageSize = 3,
  ): Observable<PaginatedResponse<SharedConnectionUsers>> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());

    return this.http.get<PaginatedResponse<SharedConnectionUsers>>(
      `${this.apiUrl}/api/admin/connections/list`,
      { params, headers: { 'X-Skip-Loader': 'true' } },
    );
  }

  getUsersForConnection(
    connectionId: number,
    search: string,
    page = 1,
    pageSize = 3,
  ): Observable<PaginatedResponse<SharedConnectionUsers>> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());

    return this.http.get<PaginatedResponse<SharedConnectionUsers>>(
      `${this.apiUrl}/api/admin/connections/${connectionId}/users`,
      { params, headers: { 'X-Skip-Loader': 'true' } },
    );
  }

  getAnnouncementDetailById(id: number): Observable<Announcement> {
    return this.http.get<Announcement>(
      `${this.apiUrl}/api/announcement/${id}/detail`,
    );
  }
}
